import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'Douleutaras/redux/store';
import { BusinessUnitsModel, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';

const businessUnitsAdapter = createEntityAdapter<JSONApiDataObject<BusinessUnitsModel>>({
  selectId: cat => cat.id
});

export const businessUnitsSlice = createSlice({
  name: 'businessUnits',
  initialState: businessUnitsAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<BusinessUnitsModel>>),
  reducers: {
    businessUnitsAdded: (state, action) => {
      businessUnitsAdapter.setMany(state, action.payload);
    }
  }
});

export const businessUnitsSelector = businessUnitsAdapter.getSelectors((state: RootState) => state.businessUnits);
